import { useEffect } from "react";

export const useEnhancedChat = () => {
  const initEmbeddedMessaging = () => {
    const { embeddedservice_bootstrap } = window;
    try {
      embeddedservice_bootstrap.settings.language = "en_US";

      embeddedservice_bootstrap.init("00Dw0000000D7va", "Enhanced_Chat", "https://healthassured.my.site.com/ESWEnhancedChat1770726347860", {
        scrt2URL: "https://healthassured.my.salesforce-scrt.com",
      });
    } catch (err) {
      console.error("Error loading Embedded Messaging:", err);
    }
  };

  useEffect(() => {
    if (!!process.env.REACT_APP_TRIGGER_ENHANCED_CHAT) {
      const script = document.createElement("script");
      script.id = "enhancedChatScript";
      script.src = "https://healthassured.my.site.com/ESWEnhancedChat1770726347860/assets/js/bootstrap.min.js";
      script.async = true;
      script.onload = () => initEmbeddedMessaging();

      document.body.appendChild(script);
    }
  }, []);

  return null;
};

declare global {
  interface Window {
    embeddedservice_bootstrap: any;
  }
}
